module.exports = __webpack_public_path__ + "static/CircularPro-BlackItalic.2503db9d.woff";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/CircularPro-BlackItalic.woff
// module id = 716
// module chunks = 168707334958949